import { ApiType } from "@gymflow/common";
import { ClubBean } from "@gymflow/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clubQueryKeys } from "./clubQueryKeys";

export function useMutationClubDetails({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      clubId,
      payload,
    }: {
      clubId: number;
      payload: Partial<ClubBean>;
    }) => {
      return (await api.clubApi.updateDetails(clubId, payload)).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: clubQueryKeys.all() });
    },
  });
}
